<template>
  <div>
    <div class="steps_body">
      <app-page-section>
        <template #title>
          {{ $t("Vento") }}
          <app-tooltip class="m-width-m">
            {{ $t("Valor característico das acções do vento") }}
          </app-tooltip>
        </template>

        <template #controls>
          <calc-phis-controls the-case="wind" />
        </template>

        <calc-form-card>
          <template #controls>
            <b-switch
              v-model="calculation.input.internal.isWindLoadsByBand"
              class="is-label_left"
              >{{ $t("Definir por banda") }}</b-switch
            >
          </template>

          <template v-if="calculation.input.internal.isWindLoadsByBand">
            <calc-form-item-wind
              the-case="wind"
              the-type="pressure"
              :title="$t('Pressão')"
            />

            <calc-form-item-wind
              the-case="wind"
              the-type="suction"
              :title="$t('Sucção')"
            />

            <template slot="illustration">
              <calc-illustration position="absolute" which="windLocal" />
            </template>
          </template>

          <template v-else>
            <calc-form-item title-style="inline" :title="$t('Pressão')">
              <calc-number-input
                v-model="singleWindPressureValue"
                :min="0"
                :max="100"
                addon="kN/m2"
              />
            </calc-form-item>

            <calc-form-item title-style="inline" :title="$t('Sucção')">
              <calc-number-input
                v-model="singleWindSuctionValue"
                :min="0"
                :max="100"
                addon="kN/m2"
              />
            </calc-form-item>

            <template slot="illustration">
              <calc-illustration which="genericLoad" />
            </template>
          </template>
        </calc-form-card>

        <calc-form-card
          optional
          v-model="calculation.input.internal.loads.windLocal"
        >
          <template #title>
            {{ $t("Vento local") }}
            <app-tooltip class="m-width-m">
              {{
                $t(
                  "As cargas definidas no vento local permitem calcular o espaçamento ótimo na zona de vento local partindo das soluções obtidas para a zona de vento corrente."
                )
              }}
            </app-tooltip>
          </template>

          <calc-form-item-wind
            the-case="windLocal"
            the-type="pressure"
            :title="$t('Pressão')"
          />

          <calc-form-item-wind
            the-case="windLocal"
            the-type="suction"
            :title="$t('Sucção')"
          />

          <template slot="illustration">
            <calc-illustration position="absolute" which="windLocal" />
          </template>
        </calc-form-card>
      </app-page-section>
    </div>

    <div class="steps_nav">
      <b-button
        class="steps_nav__btn"
        @click="$emit('prev')"
        icon-left="arrow-left"
        size="is-medium"
        type="is-primary"
        inverted
        >{{ $t("Voltar") }}</b-button
      >
      <b-button
        class="steps_nav__btn"
        @click="$emit('next')"
        icon-right="arrow-right"
        size="is-medium"
        type="is-primary"
        >{{ $t("Continuar") }}</b-button
      >
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters } from "vuex";
import CalcFormCardGenericLoadCfg from "./CalcFormCardGenericLoadCfg";
import CalcFormItemWind from "./CalcFormItemWind";
import CalcIllustration from "./CalcIllustration";
import CalcPhisControls from "./CalcPhisControls";

export default {
  name: "CalcStepWind",

  components: {
    CalcFormCardGenericLoadCfg,
    CalcFormItemWind,
    CalcPhisControls,
    CalcIllustration,
  },

  data() {
    return {
      singleWindPressureValue: 0,
      singleWindSuctionValue: 0,
    };
  },

  computed: {
    ...mapState("calculator", ["calculation"]),

    ...mapGetters("calculator", ["load", "modelSpansLength"]),

    combinationFactors() {
      return this.calculation.input.combinationFactors.wind;
    },

    pressureLoad() {
      return this.load("wind", "pressure");
    },

    suctionLoad() {
      return this.load("wind", "suction");
    },

    localPressureLoad() {
      return this.load("windLocal", "pressure");
    },

    localSuctionLoad() {
      return this.load("windLocal", "suction");
    },
  },

  watch: {
    "calculation.input.internal.loads.windLocal"(val) {
      if (!val) {
        this.resetLocalLoads();
      }
    },

    "calculation.input.internal.isWindLoadsByBand"(val) {
      if (val) {
        this.pressureLoad.value = [
          [this.singleWindPressureValue, 0],
          [this.singleWindPressureValue, 0],
          [this.singleWindPressureValue, 0],
        ];

        this.suctionLoad.value = [
          [this.singleWindSuctionValue, 0],
          [this.singleWindSuctionValue, 0],
          [this.singleWindSuctionValue, 0],
        ];
      } else {
        this.singleWindPressureValue = this.pressureLoad.value[0][0];
        this.singleWindSuctionValue = this.suctionLoad.value[0][0];
      }
    },

    singleWindPressureValue(val) {
      this.pressureLoad.value = [
        [val, this.modelSpansLength],
        [val, 0],
        [val, 0],
      ];
    },

    singleWindSuctionValue(val) {
      this.suctionLoad.value = [
        [val, this.modelSpansLength],
        [val, 0],
        [val, 0],
      ];
    },
  },

  methods: {
    resetLocalLoads() {
      this.localPressureLoad.value = [
        [0, 0],
        [0, 0],
        [0, 0],
      ];
      this.localSuctionLoad.value = [
        [0, 0],
        [0, 0],
        [0, 0],
      ];
    },
  },

  created() {
    if (!this.calculation.input.internal.isWindLoadsByBand) {
      this.singleWindPressureValue = this.pressureLoad.value[0][0];
      this.singleWindSuctionValue = this.suctionLoad.value[0][0];
    }
  },
};
</script>

<style lang="scss" scoped></style>
